import { render, staticRenderFns } from "./formInput.vue?vue&type=template&id=a53e1930&scoped=true"
import script from "./formInput.vue?vue&type=script&lang=js"
export * from "./formInput.vue?vue&type=script&lang=js"
import style0 from "./formInput.vue?vue&type=style&index=0&id=a53e1930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53e1930",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VFileInput,VRow})
